<template>
  <div>
    <CRow>
      <CCol md="12">
        
      </CCol>
    </CRow>
  </div>
</template>

<script>

export default {
  name: 'Dashboard',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
